export const API_BASE = import.meta.env.VITE_API_BASE_URL ?? 'https://api.sywyart.cn/api/v1'

export const tokenStore = {
  get: () => localStorage.getItem('shayan_admin_token'),
  set: (value: string) => localStorage.setItem('shayan_admin_token', value),
  clear: () => localStorage.removeItem('shayan_admin_token'),
}

export async function api<T>(path: string, init: RequestInit = {}): Promise<T> {
  const options: RequestInit = {
    ...init,
    headers: { 'content-type': 'application/json', ...(tokenStore.get() ? { authorization: `Bearer ${tokenStore.get()}` } : {}), ...init.headers },
  }
  const canRetry = !init.method || init.method.toUpperCase() === 'GET'
  let response: Response
  try {
    response = await fetch(`${API_BASE}${path}`, options)
  } catch (reason) {
    if (!canRetry) throw new Error('网络连接失败，请重试')
    await new Promise((resolve) => setTimeout(resolve, 350))
    try {
      response = await fetch(`${API_BASE}${path}`, options)
    } catch {
      throw new Error('网络连接失败，请检查网络后重试')
    }
  }
  const payload = await response.json().catch(() => ({}))
  if (!response.ok) throw new Error(payload.message ?? payload.code ?? `请求失败（${response.status}）`)
  return payload as T
}

export async function apiBlob(path: string): Promise<Blob> {
  let response: Response
  try {
    response = await fetch(`${API_BASE}${path}`, { headers: tokenStore.get() ? { authorization: `Bearer ${tokenStore.get()}` } : {} })
  } catch {
    throw new Error('网络连接失败，请检查网络后重试')
  }
  if (!response.ok) {
    const payload = await response.json().catch(() => ({})) as { message?: string; code?: string }
    throw new Error(payload.message ?? payload.code ?? `请求失败（${response.status}）`)
  }
  return response.blob()
}

export async function uploadAdminImage(file: File): Promise<string> {
  const supported = new Set(['image/jpeg', 'image/png', 'image/webp'])
  if (!supported.has(file.type)) throw new Error('仅支持 JPG、PNG 或 WebP 图片')
  if (file.size > 10 * 1024 * 1024) throw new Error('图片不能超过 10MB')
  const form = new FormData()
  form.append('file', file)
  let response: Response
  try {
    response = await fetch(`${API_BASE}/admin/media`, {
      method: 'POST',
      headers: tokenStore.get() ? { authorization: `Bearer ${tokenStore.get()}` } : {},
      body: form,
    })
  } catch {
    throw new Error('网络连接失败，请检查网络后重试')
  }
  const payload = await response.json().catch(() => ({})) as { publicUrl?: string; message?: string; code?: string }
  if (!response.ok) throw new Error(payload.message ?? payload.code ?? `图片上传失败（${response.status}）`)
  if (!payload.publicUrl) throw new Error('图片上传成功，但未返回图片地址')
  return payload.publicUrl
}
